import { Box } from '@mui/material';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import PageHeader from 'components/common/PageHeader/PageHeader';
import Registries from 'components/registry/Registries/Registries';
import { UsersProvider } from 'context/UsersContext';
import { ERegistryPermission } from 'enum/ERegistryPermission';
import AddIcon from 'icons/AddIcon';
import { useNavigate } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';

export default function MyRegistriesPage() {
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();

  return (
    <UsersProvider>
      <Box className={globalStyles.container} p={3}>
        <Box>
          <PageHeader
            title={'My Registries'}
            buttons={[
              <CustomButton
                key='create'
                text='Create registry'
                icon={<AddIcon size={15} />}
                onClick={() => navigate(`/registries/new-registry`)}
              />
            ]}
          />
        </Box>

        <Box mt={3}>
          <Registries group={ERegistryPermission.MINE} />
        </Box>
      </Box>
    </UsersProvider>
  )
}

